import { useNavigate } from 'react-router';
import { resetAllStoreStates, useAppDispatch } from '../../store/store';
import { clearSession } from '../utils/utils';
import { COOKIE_NAMES } from '../constants/constants';

export default function useLogout() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const logout = () => {
    //localStorage.clear();
    clearSession(COOKIE_NAMES.jwtToken);
    clearSession(COOKIE_NAMES.prismUser);
    clearSession(COOKIE_NAMES.subscription);
    resetAllStoreStates();
    // Reload is required to clear the cookie from browser tab session else it creates problem
    window.location.reload();
    window.location.href = '/signin';
    //navigate('/signin');
  };

  return { logout };
}
